// API Configuration
// Varsayılan olarak lokal backend'e düşer.
// Canlı ortamda (production) REACT_APP_API_BASE_URL environment variable ile override edilir.

const getApiBaseUrl = () => {
  const isProduction = process.env.NODE_ENV === 'production';
  const fallback = 'http://localhost:8000';

  // Production'da REACT_APP_API_BASE_URL kontrolü
  if (isProduction) {
    if (!process.env.REACT_APP_API_BASE_URL) {
      // Production'da environment variable yoksa, window.location'dan API URL'ini türet
      const hostname = window.location.hostname;
      const protocol = window.location.protocol;
      const port = window.location.port ? `:${window.location.port}` : '';
      
      // Eğer port 8001 ise (frontend portu), backend portu 8000 olmalı
      if (port === ':8001' || port === '') {
        const backendPort = hostname === 'localhost' || hostname === '127.0.0.1' ? ':8000' : ':8000';
        return `${protocol}//${hostname}${backendPort}`;
      }
      
      // Fallback: localhost:8000
      console.warn('REACT_APP_API_BASE_URL not set in production, using fallback URL');
      return fallback;
    }
    return process.env.REACT_APP_API_BASE_URL;
  }

  // Development'ta environment variable varsa kullan, yoksa fallback
  if (process.env.REACT_APP_API_BASE_URL) {
    return process.env.REACT_APP_API_BASE_URL;
  }

  return fallback;
};

export const API_BASE_URL = getApiBaseUrl();


